module.exports = __webpack_public_path__ + "media/images/workplace/intro-page/airtm-a5da9b4ac7e6776df09e388575cfc7da.svg";